import { render, staticRenderFns } from "./RequiredServices.vue?vue&type=template&id=1fe12b1a&scoped=true"
import script from "./RequiredServices.vue?vue&type=script&lang=ts"
export * from "./RequiredServices.vue?vue&type=script&lang=ts"
import style0 from "./RequiredServices.vue?vue&type=style&index=0&id=1fe12b1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe12b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe12b1a')) {
      api.createRecord('1fe12b1a', component.options)
    } else {
      api.reload('1fe12b1a', component.options)
    }
    module.hot.accept("./RequiredServices.vue?vue&type=template&id=1fe12b1a&scoped=true", function () {
      api.rerender('1fe12b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/RequiredServices.vue"
export default component.exports